import RoutePath from '../../../../../constants/routePath';

export class LearnerPortfolioRouterHelper {

  static LEARNER_PORTFOLIO_LIST_PATH = `${RoutePath.ROUTE_2BAP_LEARNERS_PORTFOLIO_LIST}`;
  static LEARNER_PORTFOLIO_IDENTIFIER = 'id';

}
